import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  GcButtonComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';

@Component({
  selector: 'app-save-buttons',
  imports: [GcButtonComponent, IpoTranslatePipe],
  templateUrl: './save-buttons.component.html',
  styleUrl: './save-buttons.component.scss',
})
export class SaveButtonsComponent {
  @Input() disableSaveButton = false;
  @Output() save = new EventEmitter();
  @Output() cancel = new EventEmitter();
}
